import { tokens } from "../../../theme";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  useTheme,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { releaseStyles } from "../styles";
import {
  formatLabelDate,
  labelStatusText,
  versionRange,
} from "../summaryHelpers";

// Terminal-state labels, collapsed by default and read-only when expanded.
const LabelGroup = ({ title, dotColor, labels = [] }) => {
  const theme = useTheme();
  const { labelsDrawer } = releaseStyles(tokens(theme.paletteId));

  if (!labels.length) {
    return null;
  }

  return (
    <Accordion disableGutters elevation={0} sx={labelsDrawer.group}>
      <AccordionSummary
        expandIcon={<ExpandMore fontSize="small" />}
        sx={labelsDrawer.groupSummary}
      >
        <Box sx={labelsDrawer.groupDot(dotColor)} />
        <Typography sx={labelsDrawer.groupName}>{title}</Typography>
        <Typography sx={labelsDrawer.groupCount}>{labels.length}</Typography>
        <Typography sx={labelsDrawer.groupRange}>
          {versionRange(labels)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={labelsDrawer.groupDetails}>
        {labels.map((label) => (
          <Box key={label?.name} sx={labelsDrawer.compactRow}>
            <Typography sx={labelsDrawer.version}>{label?.name}</Typography>
            <Typography sx={labelsDrawer.statusText("text.secondary")}>
              {labelStatusText(label?.status)}
            </Typography>
            <Typography sx={labelsDrawer.date}>
              {formatLabelDate(label?.dateCreated)}
            </Typography>
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default LabelGroup;
